/**
 * DreamPay Private API [DEPRECATED]
 * ⚠️ **DEPRECATED** - This API version is deprecated and will be removed on 2026-05-31. Please migrate to V2.  Private API v1 - Legacy endpoints for DreamPay payment processing platform.
 *
 * The version of the OpenAPI document: v1
 * Contact: suporte@dreampay.com.br
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface DreampayPayment {
  securityCode?: string;
  softDescriptor: string;
  posId: string;
  establishmentId?: number;
  establismentName: string;
  purchaseValue?: number;
  totalValueBrl?: number;
  installmentValueBrl?: number;
  paymentMethod?: number;
  installments?: number;
  readMethod?: number;
  cardHolder: string;
  cpFofCardOwner?: string;
  cpfName?: string;
  cardNumber: string;
  cardExpirationDate: string;
  cardType: string;
  exchangeRate?: number;
  orderNumber: string;
  customerName: string;
  paymentLink?: string;
  customerEmail?: string;
  currencyCode?: string;
  customerPhoneNumber?: string;
  customerAddress?: string;
  customerZipCode?: string;
  customerCity?: string;
  customerCountryId?: number;
  customerCpfCNPJ?: string;
  cardProcessingComission?: number;
  pdfUrl?: string;
}
